import React, { useEffect, useState } from "react";
import "react-widgets/styles.css";
import "react-toastify/dist/ReactToastify.css";
import LineColumns from "./LineColumns";

const AnalysisLineRight = ({
  item,
  changable,
  quantity,
  quantityUnit,
  impact,
  impact_factors,
  conversion_factor,
  checked,
  icon,
  width,
  columns,
  step,
  line_index,
  flow_id,
  color,
  is_reduce,
  totalScore,
  k_type
}) => {
  const [modifying, setModifying] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.screenX;
    setScrollPosition(scrollPosition + position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var widthvalue = width - 29.5;
  width -= 30;

  return (
    <>

      <div
        
        className={`h-[40px] w-max flex justify-start ${is_reduce ? " " : " "} ${
          modifying != 0 ? " bg-white border-gray-500 border-[1px] rounded" : color ? (color === "green" ? "bg-green-500/25" : "bg-yellow-400/25") : " bg-[#F8FAFB] border-[#F3F5F7] border-[0.1px]"
        } ${color ? (color === "green" ? "hover:bg-green-300/25" : "hover:bg-yellow-300/25") : "hover:bg-white border-[#F3F5F7] border-[0.1px]"}   items-center`}
      >
        <LineColumns
          checked={checked}
          columns={columns}
          // impact={impact}
          impact_factors={impact_factors}
          quantity={quantity}
          quantityUnit={quantityUnit}
          step={step}
          line_index={line_index}
          flow_id={flow_id}
          totalScore={totalScore}
          conversion_factor={conversion_factor}
          is_reduce={is_reduce}
          k_type={k_type}
        />
      </div>
    </>
  );
};

export default AnalysisLineRight;
